import { SigninConfiguration } from '@app/shared/models/signinConfiguration';
import { Action, createReducer, on } from '@ngrx/store';
import { SigninActions } from '../actions';

export const signinFeatureKey = 'signin';

export interface State {
  redirectSsoProcessing: boolean;
  redirectSsoSuccess: boolean;
  redirectSsoError: any;

  signinConfigurationLoading: boolean;
  signinConfigurationLoaded: boolean;
  signinConfigurationError: any;
  signinConfiguration: SigninConfiguration;

  signinWithPasswordLoading: boolean;
  signinWithPasswordSuccess: boolean;
  signinWithPasswordError: any;
}

export const initialState: State = {
  redirectSsoProcessing: false,
  redirectSsoSuccess: false,
  redirectSsoError: null,

  signinConfigurationLoading: false,
  signinConfigurationLoaded: false,
  signinConfigurationError: null,
  signinConfiguration: null,

  signinWithPasswordLoading: false,
  signinWithPasswordSuccess: false,
  signinWithPasswordError: null,
};

const signinReducer = createReducer(
  initialState,
  on(SigninActions.loadSigninConfiguration, (state) => ({
    ...state,
    signinConfigurationLoading: true,
    signinConfigurationLoaded: false,
    signinConfigurationError: null,
    signinConfiguration: null,
  })),
  on(SigninActions.loadSigninConfigurationSuccess, (state, { configuration }) => ({
    ...state,
    signinConfigurationLoading: false,
    signinConfigurationLoaded: true,
    signinConfiguration: configuration,
  })),
  on(SigninActions.loadSigninConfigurationFailure, (state, { error }) => ({
    ...state,
    signinConfigurationLoading: false,
    signinConfigurationError: error,
  })),
  // Redirect Sso
  on(SigninActions.automaticRedirectSso, (state) => ({
    ...state,
    redirectSsoProcessing: true,
    redirectSsoSuccess: false,
    redirectSsoError: null,
  })),
  on(SigninActions.automaticRedirectSsoSuccess, (state) => ({
    ...state,
    redirectSsoProcessing: false,
    redirectSsoSuccess: true,
  })),
  on(SigninActions.automaticRedirectSsoFailure, (state, { error }) => ({
    ...state,
    redirectSsoProcessing: false,
    redirectSsoError: error,
  })),
  // Signin with password
  on(SigninActions.signinWithPassword, (state) => ({
    ...state,
    signinWithPasswordLoading: true,
    signinWithPasswordSuccess: false,
    signinWithPasswordError: null,
  })),
  on(SigninActions.signinWithPasswordSuccess, (state) => ({
    ...state,
    signinWithPasswordSuccess: true,
  })),
  on(SigninActions.signinWithPasswordFailure, (state, { error }) => ({
    ...state,
    signinWithPasswordLoading: false,
    signinWithPasswordError: error,
  })),
  // Reset signin configuration
  on(SigninActions.resetSignin, (state) => ({
    ...state,
    signinConfigurationLoading: initialState.signinConfigurationLoading,
    signinConfigurationLoaded: initialState.signinConfigurationLoaded,
    signinConfigurationError: initialState.signinConfigurationError,
    signinConfiguration: initialState.signinConfiguration,

    signinWithPasswordLoading: initialState.signinWithPasswordLoading,
    signinWithPasswordSuccess: initialState.signinWithPasswordSuccess,
    signinWithPasswordError: initialState.signinWithPasswordError,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return signinReducer(state, action);
}
